<template>
  <div class="u-wrap">
    <div class="grzx-heard">
      <div class="user-top-tx">

      <div style="display: flex; align-items: center; padding: 0 24px"> 
        <img v-if="avatarUrl" class="touxia" :src="avatarUrl" />
        <img v-else class="touxia" src="@images/headerDft.png" />
        <span class="name">{{ wechatName || '昵称' }}</span>
      </div>  
        <div>
          <div class="wqd" @click="clickJfhq">积分获取</div>
          <div class="wqd" @click="clickDhjl">兑换记录</div>
        </div>
      </div>
     
    </div>
    <div class="grzx-content">
      <img src="@images/grzx/jfsc.png" class="jfsc" @click="clickJfsc" />
      <div v-for="(item, index) in cellList" :key="index" class="cell-item" @click="clickMenu(index)">
        <img :src="item.icon" class="img" />
        <span class="title">{{ item.title }}</span>
        <span v-if="index == 8" class="sub" :style="{ color: isSmrz() ? '#969696' : '#F8AE49' }">{{
          isSmrz() ? '已认证' : '待认证'
        }}</span>
        <span v-else-if="index == 10" class="sub">{{ isSmrz() ? namePrivate(object.phone) : '' }}</span>
        <span v-else class="sub">{{ item.sub }}</span>
        <van-icon name="arrow" color="#969696"></van-icon>
      </div>
    </div>
    <smrz-pop v-model="show"></smrz-pop>
  </div>
</template>

<script>
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import smrzPop from '@/views/common/smrz-pop.vue'
import { getAction, postAction, postParam } from '@/api/manage'
export default {
  mixins: [OpenIdMixin], // 使用mixin (在main.js注册全局组件)
  components: {
    smrzPop,
  },
  data() {
    return {
      currentTab: 0,
      list: [],
      avatarUrl: '',
      wechatName: '',
      show: false,
      typeShow: false,
      sysMsgTotal: '',
      cellList: [
        {
          icon: require('@images/grzx/icon-dybd.png'),
          title: '党员报到',
          sub: '党员、公职人员、志愿者',
          sfty: true,
        },
        {
          icon: require('@images/grzx/icon-cwtc.png'),
          title: '长武同城',
          sub: '',
          sfty: false,
        },
        {
          icon: require('@images/grzx/icon-wswx.png'),
          title: '社区圈',
          sub: '',
          sfty: true,
        },
         {
          icon: require('@images/grzx/icon-wyfw.png'),
          title: '物业服务',
          sub: '',
          sfty: true,
        },
        {
          icon: require('@images/grzx/icon-wdzx.png'),
          title: '我的咨询',
          sub: '',
          sfty: true,
        },
         {
          icon: require('@images/grzx/icon-ssbfk.png'),
          title: '随手报反馈',
          sub: '',
          sfty: true,
        },
         {
          icon: require('@images/grzx/icon-wtfy.png'),
          title: '问题反映',
          sub: '',
          sfty: true,
        },
        {
          icon: require('@images/grzx/icon-sfxx.png'),
          title: '身份信息',
          sub: '',
          sfty: true,
        },
        {
          icon: require('@images/grzx/icon-smrz.png'),
          title: '实名认证',
          sub: '',
          sfty: true,
        },
        {
          icon: require('@images/grzx/icon-bgjzd.png'),
          title: '变更居住地',
          sub: '',
          sfty: true,
        },
        {
          icon: require('@images/grzx/icon-xgsjh.png'),
          title: '修改手机号',
          sub: '',
          sfty: true,
        },
        {
          icon: require('@images/grzx/icon-yszc.png'),
          title: '隐私政策',
          sub: '',
          sfty: true,
        },
        {
          icon: require('@images/grzx/icon-grxxsjqd.png'),
          title: '个人信息收集清单',
          sub: '',
          sfty: true,
        },
      ],
    }
  },
  created() {
    this.initOpenId()
      .then(() => {
        this.object = this.getSmrzData()
        this.avatarUrl = this.object.avatarUrl
        this.wechatName = this.object.wechatName
      })
      .catch((err) => {})
  },
  mounted() {},
  computed: {},
  methods: {
    clickSmrz() {
      this.$router.push({
        name: 'zc',
      })
    },
    clickSjjd() {
      if (!this.isSmrz()) {
        this.show = true
        return
      }
      this.$router.push({
        name: 'sjjd',
      })
    },
    clickAjjd() {
      this.$toast('暂未开通')
    },
    goPage(pth, idx) {
      if (idx) {
        this.$toast('暂未开通')
        return
      }
      if (!this.isSmrz()) {
        this.show = true
        return
      }
      this.$router.push({
        name: pth,
      })
    },
    clickZjhf() {
      if (!this.isSmrz()) {
        this.show = true
        return
      }
      this.$router.push({
        name: 'qzly',
      })
    },
    clickWyfw() {
      if (!this.isSmrz()) {
        this.show = true
        return
      }
      this.$router.push({
        name: 'wyfwList',
      })
    },
    smrzView() {
      const { detectAuthId } = this.getSmrzData()
      let params = { id: detectAuthId }
      this.$router.push({
        name: 'smrz-view',
        query: params,
      })
    },
    onEdit(item) {
      item.sqlx = '02'
      this.$router.push({
        path: '/people/wdjr',
        query: item,
      })
    },
    onDelete(item) {
      if (item.houseRelation == '02') {
        return this.$toast('该人员为户主，请更换户主后在删除')
      }
      item.sqlx = '03'
      item.personId = item.id
      item.id = null
      postAction('/common/person/sqxg', item).then((res) => {
        if (res.success) {
          this.$toast('申请成功')
        }
      })
    },
    clickXzjr() {
      let params = { houseId: this.list[0].houseId }
      this.$router.push({
        path: '/people/wdjr',
        query: params,
      })
    },
    clickJfhq() {
      this.goSmrzPath('/gzfw/cwl')
    },
    clickTx() {},
    clickJfsc() {
       this.YzJfsc().then(()=>{
           this.goSmrzPath('/gzfw/jfsc')
        })
      
    },
     YzJfsc(){
        return new Promise((resolve, reject) => {
          
         getAction('/zhshj/jfschdgl/hdxx').then(res => {
            if (res.success) {
              let obj = res.result[0];
              if(obj.zt=='01'){
                resolve();
              }else{
                let message = `积分商城已在${obj.gbsj}关闭，开放时间：${obj.kfsj}`
                this.$toast(message)
                reject();
              }
            }else{
              reject();
            }
          });
        })
      },
    goSmrzPath(path) {
      if (this.isSmrz()) {
        this.$router.push({
          path: path,
        })
      } else {
        this.show = true
      }
    },
    clickMenu(index) {
      switch (index) {
        case 0:
          this.goSmrzPath('/dqfw/dybd')
          break
        case 1:
          this.goSmrzPath('/dqfw/ggq-list')
          break
        case 2:
          this.goSmrzPath('/gzfw/sqq-wd')
          break
        case 3:
          this.goSmrzPath('/people/wyfw-list')
          break  
        case 4:
          this.goSmrzPath('/people/qzly-list')
          break
        case 5:
          this.goSmrzPath('/people/ssb-list')
          break
        case 6:
          sessionStorage.setItem('mqztc-index',0);
          this.goSmrzPath('/people/mqztc-list')
          break
        case 7:
          this.goSmrzPath('/people/grxx')
          break
        case 8:
          if (this.isSmrz()) {
            const { detectAuthId } = this.getSmrzData()
            let params = { id: detectAuthId }
            this.$router.push({
              name: 'smrz-view',
              query: params,
            })
          } else {
            this.$router.push({ path: '/people/smrz' })
          }

          break
        case 9:
          this.goSmrzPath('/people/bgjzd')
          break
        case 10:
          this.goSmrzPath('/people/xgsjh');
          break
        case 11:
          this.$router.push({ path: '/xxgk/yszc' })
          break
        case 12:
          this.$router.push({ path: '/xxgk/xxsjqd' })
          break    
        default:
          break
      }
    },
    namePrivate(str) {
      if (!str) {
        return ''
      }
      let regular = /(\d{3})\d*(\d{4})/
      return str.replace(regular, '$1****$2')
    },
    clickDhjl(){
      // this.$toast('正在建设');
      this.goSmrzPath('/gzfw/dhjl-list');
    }
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #ffffff;
}
.grzx-heard {
  width: 100%;
  height: 178px;
  background: url('~@images/bg.png') no-repeat;
  background-size: 100% 100%;
}

.user-top-tx {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 15px 0;

  .tx-p {
    position: relative;
    margin-right: 15px;

    .tx {
      position: absolute;
      width: 8px;
      height: 8px;
      background: #ff4848;
      border-radius: 50%;
      top: 0;
      right: 0;
    }
  }

   .wqd {
        padding: 0 15px;
        height: 24px;
        line-height: 24px;
        background: #F9EDD2;
        box-shadow: inset 0 0 4px 0 #ffffff80;
        border-radius: 2px;
        font-weight: 500;
        font-size: 12px;
        color: #FF7E3B;
        margin-bottom: 5px;
      }
}

.touxia {
  width: 54px;
  height: 54px;
  background-color: #fff;
  border-radius: 50%;
}

.name {
  font-size: 17px;
  color: #ffffff;
  line-height: 24px;
  margin-left: 10px;
}

.rzzt {
  margin-left: auto;
  width: 73px;
  height: 26px;
  display: flex;
  justify-content: center;
  background: rgba(255, 255, 255, 0.29);
  border-radius: 13px;
  color: #fff;
  font-size: 13px;
  line-height: 26px;
}

.grzx-card {
  margin: 0 14px;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 0rpx rgba(153, 153, 153, 0.16);
  border-radius: 12px;
  margin-top: -60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-item .img {
  width: 29px;
  height: 29px;
}

.card-item .text {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  line-height: 18px;
  margin-top: 4px;
}

.dhzjgk {
  width: 92%;
  margin-top: 12px;
  margin-left: 4%;
}

.wdjr-p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;

  .tit {
    font-size: 15px;
    color: #000;
    font-weight: bold;
  }
  .add {
    font-size: 14px;
    color: #4e8dff;
  }
}

.grzx-content {
  padding: 15px;
  position: relative;
  margin-top: -92px;

  .jfsc {
    width: 100%;
    height: auto;
    margin-bottom: 5px;
  }

  .cell-item {
    display: flex;
    align-items: center;
    height: 40px;

    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    .title {
      font-size: 16px;
      color: #1a1a1a;
    }

    .sub {
      flex: 1;
      text-align: right;
      font-size: 14px;
      color: #969696;
    }
  }
}
</style>
